<template>
  <div class="add-metric-button" data-testid="add-metric-button">
    <Button text iconLeft="mdi-plus" data-testid="add-metric-btn" @click="$emit('click')">
      Add Metric
    </Button>
  </div>
</template>

<script>
import Button from "@/components/generic/Button.vue";

export default {
  name: "AddMetricButton",
  components: { Button },
  emits: ["click"],
};
</script>

<style scoped>
/* Sized and bordered to sit alongside MetricColumn in a row, at the single-weight
   border the design gives an unconfigured slot. */
.add-metric-button {
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  min-height: 52px;
  align-items: center;
  justify-content: center;
  padding: 8px 8px 8px 16px;
  border: 1px solid var(--v-grey-base);
  border-radius: 4px;
}
</style>
